module.exports = "td {\r\n    cursor: pointer;\r\n}\r\n"